// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3m6AQ","right":"Footer_right__3kmR6","buttons":"Footer_buttons__3eBf4"};